export default "/_next/static/sounds/scott-someoneisfollowingme-f7a370fe61ab9d4d1ed8443a09f86ad1.mp3";